import { MentionSuggestion } from "../mentions";
import PropTypes from "prop-types";
import React from "react";

export default function StandardMentionSuggestionItem({ isSelected, suggestion, acceptSuggestion, children }) {
  return (
    <li
      onClick={() => acceptSuggestion(suggestion)}
      css={{
        padding: 12,
        cursor: "pointer",
        userSelect: "none",

        "& > *": {
          cursor: "pointer",
          pointerEvents: "none",
        },

        "&:hover": {
          // pre-select
          backgroundColor: isSelected ? "#66a0ff" : "#eef4ff",
        },

        backgroundColor: isSelected ? "#005aee" : null,
        color: isSelected ? "#ffffff" : "inherit",

        "&:first-of-type": {
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        },

        "&:last-of-type": {
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
        },
      }}
    >
      {children}
    </li>
  );
}

StandardMentionSuggestionItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  suggestion: PropTypes.instanceOf(MentionSuggestion).isRequired,
  acceptSuggestion: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};
